export default __webpack_public_path__ + "static/media/Wolf's Leggings of the Covert Trail.32ce2fa9.jpg";